import type {
  EmptyMaterialInstallationWithColor,
  MaterialInstallationBase,
  MaterialInstallationWithColor
} from '@refra/modules/refra-planning/types'

const MISSING_INSTALLATION_COLOR = '#bababa'
const EVEN_INSTALLATION_COLOR = '#52667A'
const ODD_INSTALLATION_COLOR = '#8599AD'

const getEmptyMaterialToRender = (
  fromMeter: number,
  toMeter: number
): EmptyMaterialInstallationWithColor => ({
  id: -1,
  refractoryId: -1,
  fromMeter,
  toMeter,
  isMortarRequired: false,
  feedingDate: '',
  color: MISSING_INSTALLATION_COLOR,
  performance: {heatZones: []},
  localColor: MISSING_INSTALLATION_COLOR,
  globalColor: MISSING_INSTALLATION_COLOR,
  refractoryName: '',
  manufacturerName: '',
  comments: []
})

export const getKilnMaterialInstallationsWithColor = <T extends MaterialInstallationBase>(
  kilnMaterialInstallations: T[],
  kilnWidth: number
): Array<MaterialInstallationWithColor<T> | EmptyMaterialInstallationWithColor> => {
  let lastMaterial: T | EmptyMaterialInstallationWithColor
  const kilnMaterialInstallationsWithColor: Array<
    MaterialInstallationWithColor<T> | EmptyMaterialInstallationWithColor
  > = []

  kilnMaterialInstallations.forEach((material, index) => {
    if (lastMaterial && lastMaterial.toMeter !== material.fromMeter) {
      kilnMaterialInstallationsWithColor.push(
        getEmptyMaterialToRender(lastMaterial.toMeter, material.fromMeter)
      )
    }

    const customColor = index & 1 ? EVEN_INSTALLATION_COLOR : ODD_INSTALLATION_COLOR
    lastMaterial = material
    kilnMaterialInstallationsWithColor.push({
      ...material,
      color: customColor
    })
  })

  const hasKilnMaterialInstallations = kilnMaterialInstallationsWithColor.length > 0

  if (!hasKilnMaterialInstallations) {
    kilnMaterialInstallationsWithColor.push(getEmptyMaterialToRender(0, kilnWidth))
  }

  lastMaterial = kilnMaterialInstallationsWithColor[kilnMaterialInstallationsWithColor.length - 1]

  if (lastMaterial && lastMaterial.toMeter !== kilnWidth) {
    kilnMaterialInstallationsWithColor.push(
      getEmptyMaterialToRender(lastMaterial.toMeter, kilnWidth)
    )
  }

  const firstMaterial = kilnMaterialInstallationsWithColor[0]

  if (firstMaterial && firstMaterial.fromMeter !== 0) {
    kilnMaterialInstallationsWithColor.unshift(getEmptyMaterialToRender(0, firstMaterial.fromMeter))
  }

  return kilnMaterialInstallationsWithColor
}
